import React, { useState } from "react";
import "../styles/servicios.css";

// Imágenes de cada servicio
import sanacionesImg from "../images/sanaciones.jpeg";
import limpiezasImg from "../images/limpieza.jpeg";
import cartasImg from "../images/lectura.jpeg";
import energiaImg from "../images/conecta.jpeg";
import cursoImg from "../images/curso2.jpeg";
import ayudaImg from "../images/ayudar.jpeg";


export default function Servicios() {
  const [abiertos, setAbiertos] = useState({});

  const toggleServicio = (id) => {
    setAbiertos((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const servicios = [
    {
      id: 1,
      titulo: "Sanaciones Angélicas",
      imagen: sanacionesImg,
      items: [
        "Libera bloqueos emocionales",
        "Encuentra armonía en tus relaciones, finanzas y salud",
        "Agendá tu sesión hoy y transformá tu vida",
      ],
    },
    {
      id: 2,
      titulo: "Limpiezas Energéticas",
      imagen: limpiezasImg,
      items: [
        "Purifica tu hogar, negocio y espacios",
        "Recuperá la paz y el equilibrio con la ayuda de los arcángeles",
        "Contactame y armonizá tu energía ahora",
      ],
    },
    {
      id: 3,
      titulo: "Lectura de Cartas Angélicas",
      imagen: cartasImg,
      items: [
        "Mensajes claros y guía espiritual para tus decisiones",
        "Descubrí qué quieren decirte los ángeles hoy",
        "Reservá tu lectura y recibí su mensaje",
      ],
    },
    {
      id: 4,
      titulo: "Conecta con la Energía de los Ángeles",
      imagen: energiaImg,
      items: [
        "Canalizá la energía celestial para tu crecimiento interior",
        "Recibí orientación y sanación espiritual",
      ],
    },
    {
      id: 5,
      titulo: "Curso de Tarot de Ángeles",
      imagen: cursoImg,
      items: [
        "Aprendé a leer las cartas",
        "Saná emociones y desbloqueá energías",
        "Guía a otros con tu intuición angelical",
        "Conectá con los ángeles y transformá tu vida",
        "Reservá tu lugar y recibí su mensaje",
      ],
    },
    {
      id: 6,
      titulo: "Productos consagrados",
      imagen: ayudaImg,
      items: [
        "Sanaciones angélicas",
        "Invocaciones y consagraciones angelicales",
        "Energizaciones y endulces espirituales",
        "Trabajos con ángeles negativos, logrando equilibrio universal",
        "Limpiezas energéticas de personas, casas, negocios y espacios",
      ],
    },
  ];

  return (
    <section id="servicios" className="servicios-section">
      <h2 className="servicios-titulo">Mis Servicios</h2>

      <div className="servicios-grid">
        {servicios.map((servicio) => (
          <div key={servicio.id} className="servicio-card">
            <div className="servicio-imagen">
              <img src={servicio.imagen} alt={servicio.titulo} />

              {/* Contenido desplegable sobre la imagen */}
              <div
                className={`overlay ${
                  abiertos[servicio.id] ? "visible" : "oculto"
                }`}
              >
                <ul>
                  {servicio.items.map((item, index) => (
                    <li key={index}>⭐ {item}</li>
                  ))}
                </ul>
              </div>
            </div>

            <div
              className="servicio-header"
              onClick={() => toggleServicio(servicio.id)}
            >
              <h3>{servicio.titulo}</h3>
              <span className={`flecha ${abiertos[servicio.id] ? "abierto" : ""}`}>
                {abiertos[servicio.id] ? "▲" : "▼"}
              </span>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}